import {
  HttpInterceptorFn,
  HttpRequest,
  HttpHandlerFn,
} from '@angular/common/http';
import { API_BASE_URL } from '../injectors';
import { inject } from '@angular/core';

export const baseUrlInterceptor: HttpInterceptorFn = (
  req: HttpRequest<any>,
  next: HttpHandlerFn
) => {
  const apiUrl = inject(API_BASE_URL);

  if (req.url.startsWith('/api')) {
    const updatedReq = req.clone({
      url: `${apiUrl}${req.url}`,
    });
    return next(updatedReq);
  }

  return next(req);
};
